var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-8"},[_c('simple-button',{staticClass:"mt-3",attrs:{"text":"buy more credits"},on:{"click":function($event){return _vm.$router.push('/shop')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }